<template>
    <div>
        <van-nav-bar
        title="店铺简介"
        />
        <van-loading vertical v-if="loading"/>
        <van-cell-group  v-if="shopinfo.name">
            <van-cell size="large" :title="shopinfo.name"  :label="shopinfo.description" />
            <van-cell size="large" title="主要业务"  :label="shopinfo.business_names" />
            <van-cell size="large" title="联系方式">
                <template slot="label">
                    <span style="display:block;">{{"联系人："}}{{shopinfo.contact_name}}</span>
                    <span style="display:block;">{{"手机号："}}{{shopinfo.contace_mobile}}</span>
                    <span style="display:block;">{{"店铺电话："}}{{shopinfo.telephone}}</span>
                </template>
            </van-cell>
            <van-cell size="large" title="店铺地址"  :label="shopinfo.address"  is-link @click="toMap()" />
        </van-cell-group>

        <van-divider dashed v-if="!shopinfo.name">您还没有关注店铺</van-divider>
    </div>
</template>

<script>
import { Cell, CellGroup, NavBar, Loading, Divider, Toast } from 'vant';
import { UserShopInfoApi } from '@/api/shop'
import { toErrorPage } from '@/utils/usePage'

export default {
    components: {
        [Cell.name]: Cell,
        [CellGroup.name]: CellGroup,
        [NavBar.name]: NavBar,
        [Loading.name]: Loading,
        [Divider.name]: Divider,
        [Toast.name]: Toast
    },
    data() {
        return {
            loading: true,
            shopinfo: {
                name: '',
                description: '',
                address: '',
                contact_name: '',
                contace_mobile: '',
                telephone:'',
                business_names:'',
                city_name:''
            }
        }
    },
    mounted(){
        this.getShopInfo()
    },
    methods: {
        getShopInfo() {
            var that = this
            that.axios.get(UserShopInfoApi,{params: {type:'info'} }).then((ret) => {
                this.loading = false
                if (ret.flag) {
                    ret = ret.details
                    that.shopinfo = {
                        name: ret.name?ret.name:'',
                        description: ret.description?ret.description:'',
                        address: ret.address?ret.address:'',
                        contact_name: ret.contact_name?ret.contact_name:'',
                        contace_mobile: ret.contace_mobile?ret.contace_mobile:'',
                        telephone: ret.telephone?ret.telephone:'',
                        city_name: ret.city_name?ret.city_name:''
                    }
                    this.shopinfo.business_names = ''
                    ret.business.forEach((item) => {
                        this.shopinfo.business_names += item.name + '，'
                    })
                    this.shopinfo.business_names = this.shopinfo.business_names.substring(0, this.shopinfo.business_names.length-1)
                } else {
                    toErrorPage(this,'',ret.info,null)
                }
            })
        },
        toMap(){
            // window.location.href = `https://apis.map.qq.com/uri/v1/search?region=${encodeURIComponent(this.shopinfo.city_name)}&keyword=${encodeURIComponent(this.shopinfo.address)}`
            window.location.href = `https://apis.map.qq.com/uri/v1/search?center=CurrentLocation&radius=5000&keyword=${encodeURIComponent(this.shopinfo.address)}`
       }
    }
}
</script>

<style lang="less" scoped>

</style>